import { render, staticRenderFns } from "./folderTree.vue?vue&type=template&id=6ef7dede&scoped=true&"
import script from "./folderTree.vue?vue&type=script&lang=js&"
export * from "./folderTree.vue?vue&type=script&lang=js&"
import style0 from "./folderTree.vue?vue&type=style&index=0&id=6ef7dede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef7dede",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef7dede')) {
      api.createRecord('6ef7dede', component.options)
    } else {
      api.reload('6ef7dede', component.options)
    }
    module.hot.accept("./folderTree.vue?vue&type=template&id=6ef7dede&scoped=true&", function () {
      api.rerender('6ef7dede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/tree/folderTree.vue"
export default component.exports